export default __webpack_public_path__ + "static/media/P-002.7bab386d.png";